<nav *ngIf='linkedAccountState' class="navbar navbar-expand-lg">

  <div class="container-fluid linked-account-header">

    <div class="ms-auto me-auto">
      You are currently working as {{linkedAccountState.currentUser}} in the account that belongs to {{linkedAccountState.linkedAccountName}}.
      <span *ngIf="displayTokenExpirationTime">Access to this linked account will expire at {{tokenExpirationTime}}</span>
    </div>


    <div class="d-flex">
      <div class="me-2">
        <button id="returntomanagingaccount" class="btn btn-sm btn-tertiary" i18n (click)="returnToManagerAccount()">Return to Managing Account</button>
      </div>
    </div>
  </div>
</nav>


<p-dialog i18n-header [closable]="false" [(visible)]="displayDialog" header="Linked Account Access Expiring" [modal]="true" [style]="{width: '500'}">
  <p i18n>
    Your access to this linked account is about to expire.
  </p>
  <p>
    <span i18n>In</span>
    <span class="countdown">{{timeLeft}}</span>
    <span i18n>minutes, you will be automatically logged out.</span>
  </p>
  <p i18n>
    You can link back into this account from your Linked Accounts tabs and renew your
    access to this linked account.
  </p>
  <p-footer>
    <button i18n type="button" id="continueworking" class="btn btn-primary" (click)="continueWorking()">Continue Working</button>
    <button i18n type="button" id="returntomgr" class="btn btn-primary" (click)="returnToManagerAccount()">Return to Managing Account</button>
  </p-footer>
</p-dialog>